import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { IcHandshake, IcPlus, IcEdit, IcList, IcPdf, IcExcel } from '../../../Icons';
import axios from 'axios';
import {
  ButtonGroup,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from 'reactstrap';
import Header from '../../../layout/Header/Header';
import Swal from 'sweetalert2';
import Baja from '../../Baja';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { pdfHeader, pdfFooter, pdfTableStyles } from '../../../../pdfUtils';
import ExportJsonExcel from 'js-export-excel';

function ListadoSocios() {
  const { user } = useContext(AuthContext);
  const URL_SOCIOS       = process.env.REACT_APP_URL_SOCIOS;
  const URL_RETIROS      = process.env.REACT_APP_URL_RETIROS;
  const URL_LOGS         = process.env.REACT_APP_URL_LOGS;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;

  const [socios, setSocios] = useState([]);
  const [movs,   setMovs]   = useState([]);

  // ── Edit modal ────────────────────────────────────────────────────────────
  const [modal,  setModal]  = useState(false);
  const toggle              = () => setModal(!modal);
  const [idEdit,        setIdEdit]        = useState("");
  const [name,          setName]          = useState('');
  const [participacion, setParticipacion] = useState(0);

  // ── Movimientos modal ─────────────────────────────────────────────────────
  const [modalMovs, setModalMovs] = useState(false);
  const toggleMovs                = () => setModalMovs(!modalMovs);
  const [nameMovs,          setNameMovs]          = useState('');
  const [participacionMovs, setParticipacionMovs] = useState(0);

  // ── Create modal ──────────────────────────────────────────────────────────
  const [modalCreate,       setModalCreate]       = useState(false);
  const toggleCreate                              = () => setModalCreate(!modalCreate);
  const [nameNew,           setNameNew]           = useState('');
  const [participacionNew,  setParticipacionNew]  = useState(0);
  const [validaBoton,       setValidaBoton]       = useState(true);

  useEffect(() => {
    axios
      .get(URL_SOCIOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
      })
      .then((response) => setSocios(response.data))
      .catch(() => {});
  }, []);

  // ── Create ────────────────────────────────────────────────────────────────
  function saveSocios(event) {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(URL_SOCIOS, { name: nameNew, participacion: participacionNew, porRetirar: 0, realRetirado: 0 }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: 'Crear Socio', detalle: nameNew, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
        });
        setNameNew(''); setParticipacionNew(0); setValidaBoton(true);
        toggleCreate();
        Swal.fire('¡Listo!', 'Socio creado con éxito', 'success');
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!', footer: `${error.response?.data}` });
        setValidaBoton(true);
      });
  }

  // ── Edit ──────────────────────────────────────────────────────────────────
  function editSocio(event) {
    event.preventDefault();
    axios
      .patch(`${URL_SOCIOS}/${idEdit}`, { name, participacion }, {
        headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
      })
      .then(() => {
        axios.post(URL_LOGS, { tipo: 'Editar Socio', detalle: name, user: user.id }, {
          headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
        });
        toggle();
        Swal.fire('¡Listo!', 'Actualizado con éxito', 'success');
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!', footer: `${error.response?.data}` });
      });
  }

  function jalaInfo(idEdit, name, participacion) {
    setName(name);
    setParticipacion(participacion);
    setIdEdit(idEdit);
    toggle();
  }

  function jalaMovs(id, name, participacion) {
    setNameMovs(name);
    setParticipacionMovs(participacion);
    axios
      .get(`${URL_ESTADO_CUENTA}Socio/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem('app_token')}` },
      })
      .then((response) => setMovs(response.data))
      .catch(() => {});
    toggleMovs();
  }

  // ── PDF & Excel ───────────────────────────────────────────────────────────
  function PDFOC() {
    let TotalSaldo = 0, TotalRetirado = 0, TotalRepartido = 0;
    const data = movs.map((a) => {
      TotalSaldo     = TotalSaldo     + a.reparto - a.retirado;
      TotalRetirado  = TotalRetirado  + a.retirado;
      TotalRepartido = TotalRepartido + a.reparto;
      const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(n);
      return [a.fecha, a.observaciones, fmt(a.reparto), fmt(a.retirado), fmt(TotalSaldo)];
    });
    const doc = new jsPDF('landscape');
    const startY = pdfHeader(doc, "Retiros", nameMovs);
    const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(n);
    doc.autoTable({
      ...pdfTableStyles(),
      head: [['Fecha', 'Observaciones', 'Reparto', 'Retirado', 'Saldo']],
      body: data.filter((el) => el != null),
      startY,
      foot: [['', 'Total', fmt(TotalRepartido), fmt(TotalRetirado), fmt(TotalSaldo)]],
    });
    pdfFooter(doc);
    doc.save(`Retiros.pdf`);
  }

  function excel() {
    const option = {
      fileName: `Retiros ${nameMovs}`,
      datas: [{
        sheetData: movs.map((a) => ({ Fecha: a.fecha, Observaciones: a.observaciones, Reparto: a.reparto, Retirado: a.retirado })),
        sheetName: 'Retiros',
        sheetFilter: ['Fecha', 'Observaciones', 'Reparto', 'Retirado'],
        sheetHeader: ['Fecha', 'Observaciones', 'Reparto', 'Retirado'],
      }],
    };
    new ExportJsonExcel(option).saveExcel();
  }

  const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(n);

  let totalPorRetirar = 0;
  let totalRealRetirado = 0;
  let totRetirado = 0;
  let totRepartido = 0;
  let saldo = 0;

  return (
    <>
      <Header />
      {user.menu_usuarios ? (
        <div className="card container col-sm-10">

          {/* ── Page header ──────────────────────────────────────────────── */}
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcHandshake style={{ marginRight: 8, color: "#f59e0b" }} />
                Socios
              </h3>
              <p className="page-subtitle">Participación y estado de cuenta de socios</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nuevo Socio
              </Button>
            </div>
          </div>

          {/* ── Tabla ────────────────────────────────────────────────────── */}
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Participación</th>
                <th>Por Retirar</th>
                <th>Retirado Real</th>
                <th>Saldo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {socios
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  totalPorRetirar   = totalPorRetirar   + a.porRetirar;
                  totalRealRetirado = totalRealRetirado + a.realRetirado;
                  return (
                    <tr key={a._id}>
                      <td>{a.name}</td>
                      <td>{a.participacion}%</td>
                      <td>{fmt(a.porRetirar)}</td>
                      <td>{fmt(a.realRetirado)}</td>
                      <td>{fmt(a.porRetirar - a.realRetirado)}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <Button color="info" size="sm" onClick={() => jalaInfo(a._id, a.name, a.participacion)}>
                            <IcEdit />
                          </Button>
                          <Button color="success" size="sm" title="Ver movimientos" onClick={() => jalaMovs(a._id, a.name, a.participacion)}>
                            <IcList />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              <tr>
                <td></td>
                <td className="negrita" align="center">TOTAL</td>
                <td className="negrita">{fmt(totalPorRetirar)}</td>
                <td className="negrita">{fmt(totalRealRetirado)}</td>
                <td className="negrita"></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {/* ── Modal: Nuevo Socio ────────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcPlus style={{ marginRight: 8, color: "#10b981" }} />
          Nuevo Socio
        </ModalHeader>
        <ModalBody>
          <Label>Nombre del Socio</Label>
          <Input type="text" placeholder="Nombre" value={nameNew} required
            onChange={(e) => setNameNew(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Participación (%)</Label>
          <Input type="number" value={participacionNew} required
            onChange={(e) => setParticipacionNew(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveSocios} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Editar Socio ───────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <IcEdit style={{ marginRight: 8, color: "#3b82f6" }} />
          Editar Socio
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input type="text" value={name} required
            onChange={(e) => setName(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Participación (%)</Label>
          <Input type="number" value={participacion} required
            onChange={(e) => setParticipacion(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editSocio}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Estado de Cuenta ───────────────────────────────────────── */}
      <Modal size="lg" isOpen={modalMovs} toggle={toggleMovs}>
        <ModalHeader toggle={toggleMovs}>
          <h4>Estado de Cuenta — {nameMovs}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <ButtonGroup size="sm">
              <Button color="danger" onClick={PDFOC}>
                <IcPdf style={{ marginRight: 4 }} /> PDF
              </Button>
              <Button color="success" onClick={excel}>
                <IcExcel style={{ marginRight: 4 }} /> Excel
              </Button>
            </ButtonGroup>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Observaciones</th>
                <th>Reparto</th>
                <th>Retiro</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              {movs.map((c) => {
                totRetirado  = totRetirado  + c.retirado;
                totRepartido = totRepartido + c.reparto;
                saldo        = saldo + c.reparto - c.retirado;
                return (
                  <tr key={c._id}>
                    <td>{c.fecha}</td>
                    <td>{c.observaciones}</td>
                    <td>{fmt(c.reparto)}</td>
                    <td>{fmt(c.retirado)}</td>
                    <td>{fmt(saldo)}</td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">{fmt(totRepartido)}</td>
                <td className="negrita">{fmt(totRetirado)}</td>
                <td className="negrita">{fmt(saldo)}</td>
              </tr>
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleMovs}>Cerrar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoSocios;
